import { FC } from "react";

import { SvgIconConstituentValues } from "types/common";

export const ImportExportIcon: FC<SvgIconConstituentValues> = ({
  fill,
  ...props
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Placeholder" clipPath="url(#clip0_3588_11792)">
      <path
        id="Vector"
        d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM16 17.01V10H14V17.01H11L15 21L19 17.01H16Z"
        fill={fill || "black"}
      />
    </g>
    <defs>
      <clipPath id="clip0_3588_11792">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
